import { EDayOfWeek } from "../../Enum/EDayOfWeek"

export class OperatingScheduleEntity {
  id: number

  day: EDayOfWeek

  openTime: string

  closeTime: string

  dayEnable: boolean

  constructor(data: Partial<OperatingScheduleEntity> = {}) {
    this.id = data.id ?? -1

    this.day = data.day ?? EDayOfWeek.Monday

    this.openTime = data.openTime ?? ""

    this.closeTime = data.closeTime ?? ""

    this.dayEnable = data.dayEnable ?? true
  }

  isOpen(date: Date = new Date()): boolean {
    if (this.dayEnable === false) {
      return false
    }

    const nowMinutes = date.getHours() * 60 + date.getMinutes()

    const [openH, openM] = this.openTime.split(":").map(Number)

    const [closeH, closeM] = this.closeTime.split(":").map(Number)

    const openMinutes = openH * 60 + openM

    const closeMinutes = closeH * 60 + closeM

    if (openMinutes < closeMinutes) {
      return nowMinutes >= openMinutes && nowMinutes < closeMinutes
    }

    return nowMinutes >= openMinutes || nowMinutes < closeMinutes
  }
}
